export class UiUtils {
  public static doEvents(timeout: number): Promise<void> {
    return new Promise<void>(resolve => {
      setTimeout(resolve, timeout);
    })
  }
}
